export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ActivationPanel.vue?vue&type=template&id=3418e372&"


//////////////////
// WEBPACK FOOTER
// ./src/views/activation/ActivationPanel.vue?vue&type=template&id=3418e372&
// module id = 1412
// module chunks = 0